<app-header></app-header>

<ion-content scrollbar class="ion-no-padding">
  
  <ng-container *ngIf="page === 'guestReport'">
    <app-guest-report ></app-guest-report>
  </ng-container>
  
  <ng-container *ngIf="page === 'submissionsReport'">
    <app-submissions-report></app-submissions-report>
  </ng-container>

  <ng-container *ngIf="page === 'parkingReport'">
    <app-parking-report></app-parking-report>
  </ng-container>
  
</ion-content>
